<template>
<v-card>
    <v-card-title style="background-color: #2b3990">
      <span class="headline white--text">{{ titleForm  }}</span>
  </v-card-title>
  <v-card-text>
      <v-container>
      <v-row>
          <v-col cols="12" sm="12" md="3">
            <v-autocomplete
                  label="Vehicle"
                  v-model="VehicleType"
                  :items="vehicles"
                  prepend-icon="local_taxi"
              ></v-autocomplete>
          </v-col>
          
          <v-col cols="12" sm="12" md="3" v-if="VehicleType==='Other'">
              <v-text-field
                v-model="vehicleData.OtherVehicleType"
                label="Other"
                prepend-icon="local_taxi"
              ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
          <v-text-field
              v-model="vehicleData.Start"
              label="Starting Miles"
              prepend-icon="speed"
          ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
          <v-text-field
              v-model="vehicleData.End"
              label="Ending Miles"
              prepend-icon="speed"

          ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3">
          
          <v-menu
              ref="menu"
              v-model="menu"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
              <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="vehicleData.Date"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clearable
              ></v-text-field>
              </template>
              <v-date-picker
              v-model="vehicleData.Date"
              no-title
              scrollable
              >
              <v-spacer></v-spacer>
              <!-- <v-btn
                  text
                  color="primary"
                  @click="menu = false"
              >
                  Cancel
              </v-btn>
              <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(date)"
              >
                  OK
              </v-btn> -->
              </v-date-picker>
          </v-menu>
          </v-col>

          <v-col cols="12">
              <h2>INTERIOR</h2>
              <v-divider></v-divider> 
          </v-col>

          <v-col cols="12" md="4">
              <span>Current Registration and Insurance (Sealed Envelope):</span>
          <v-checkbox
              v-model="vehicleData.Registration"
              label="Yes"
              value="Yes"

              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Registration"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Gauges (any engine lights, dash lights on):</span>
          <v-checkbox
            v-model="vehicleData.Gauges"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Gauges"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Air Condition / Heat Working:</span>
          <v-checkbox
              v-model="vehicleData.Heater"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Heater"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Fire Extinguisher: </span>
          <v-checkbox
              v-model="vehicleData.Fire"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Fire"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>First Aid Kit: </span>
          <v-checkbox
              v-model="vehicleData.FirstAid"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.FirstAid"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>All Seatbelts Functional: </span>
          <v-checkbox
              v-model="vehicleData.Seatbelts"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Seatbelts"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>
          
          <v-col cols="12" md="4">
              <span>Vehicle Clean Inside:</span>
          <v-checkbox
            v-model="vehicleData.Inside"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Inside"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Rear View Mirror: </span>
          <v-checkbox
              v-model="vehicleData.RearView"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.RearView"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>
         

          <!-- <v-col cols="12" md="4">
              <span>Seat Covers If Any:</span>
          <v-checkbox
              v-model="vehicleData.SeatCovers"
              label="Yes"
              value="Yes"

              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.SeatCovers"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col> -->

          <v-col md="4"></v-col>

          <v-col cols="12">
              <h2>EXTERIOR</h2>
              <v-divider></v-divider> 
          </v-col>

          <v-col cols="12" md="4">
              <span>Tire treads or crack on tires:</span>
          <v-checkbox
              v-model="vehicleData.TireTread"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.TireTread"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Vehicle Clean Outside:</span>
          <v-checkbox
              v-model="vehicleData.Outside"
              label="Yes"
              value="Yes"

              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Outside"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="3">
            <v-menu
              ref="menu2"
              v-model="menu2"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
              <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="vehicleData.CarWashDate"
                  label="Car Wash Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clearable
              ></v-text-field>
              </template>
              <v-date-picker
              v-model="vehicleData.CarWashDate"
              no-title
              scrollable
              >
              <v-spacer></v-spacer>
              <!-- <v-btn
                  text
                  color="primary"
                  @click="menu2 = false"
              >
                  Cancel
              </v-btn>
              <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(date)"
              >
                  OK
              </v-btn> -->
              </v-date-picker>
          </v-menu>
          </v-col>


          <v-col cols="12" md="4">
              <span>Any Damages to Exterior of Vehicle:</span>
          <v-checkbox
              v-model="vehicleData.Damage"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Damage"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" v-if="vehicleData.Damage == 'Yes'">
            <v-textarea
                outlined
                label="Damage Explanation"
                v-model="vehicleData.DamageExplanation"
            ></v-textarea>
          </v-col>

          

          <v-col cols="12" md="4">
              <span>Side Mirrors Intact and Working:</span>
            <v-checkbox
                v-model="vehicleData.Mirrors"
                label="Yes"
                value="Yes"
                dense
            ></v-checkbox>
            <v-checkbox
                v-model="vehicleData.Mirrors"
                label="No"
                value="No"
                dense
            ></v-checkbox>
          </v-col>

          <!-- <v-col cols="12" md="4">
              <span>Front End Body:</span>
          <v-checkbox
              v-model="vehicleData.Front"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Front"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Rear End Body: </span>
          <v-checkbox
              v-model="vehicleData.Rear"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Rear"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Roof: </span>
          <v-checkbox
              v-model="vehicleData.Roof"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Roof"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Windshield: </span>
          <v-checkbox
              v-model="vehicleData.Windshield"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Windshield"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Windows: </span>
          <v-checkbox
              v-model="vehicleData.Windows"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Windows"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Passenger Side Mirror: </span>
          <v-checkbox
              v-model="vehicleData.PassMirror"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.PassMirror"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Driver Side Mirror: </span>
          <v-checkbox
              v-model="vehicleData.DriverMirror"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.DriverMirror"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Tires/Wheels Front:</span>
          <v-checkbox
              v-model="vehicleData.TiresFront"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.TiresFront"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Tires/Wheels Rear: </span>
          <v-checkbox
              v-model="vehicleData.TiresRear"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.TiresRear"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Gas Cap:</span>
          <v-checkbox
              v-model="vehicleData.Cap"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Cap"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Leaks:</span>
          <v-checkbox
              v-model="vehicleData.Leaks"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Leaks"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col> -->

          <v-col cols="12" md="4">
              <span>Spare Tire:</span>
          <v-checkbox
              v-model="vehicleData.Spare"
              label="Yes"
              value="Yes"

              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Spare"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col> 

          <v-col cols="12" md="8"></v-col>

          <v-col cols="12">
              <h2>MECHANICAL</h2>
              <v-divider></v-divider> 
          </v-col>

          <v-col cols="12" md="4">
              <span>Windows Clean and Wipers Functional: </span>
          <v-checkbox
              v-model="vehicleData.Windows"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Windows"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Reverse and Brake Lights Working:</span>
          <v-checkbox
              v-model="vehicleData.Reverse"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Reverse"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Hazard Lights Working:</span>
          <v-checkbox
              v-model="vehicleData.Hazard"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Hazard"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Head Lights Working:</span>
          <v-checkbox
              v-model="vehicleData.Lights"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Lights"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Turn Signals Working:</span>
          <v-checkbox
              v-model="vehicleData.Signals"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Signals"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Horn Working:</span>
          <v-checkbox
              v-model="vehicleData.Horn"
              value="Yes"
              label="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Horn"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>


          <v-col cols="12" md="4">
              <span>Any Unexplained Puddles Under Vehicle:</span>
          <v-checkbox
              v-model="vehicleData.Puddles"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Puddles"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          

          <!-- <v-col cols="12">
              <h2>INTERIOR</h2>

          </v-col>


          

          <v-col cols="12" md="4">
              <span>Dash: </span>
          <v-checkbox
              v-model="vehicleData.Dash"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Dash"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          

          <v-col cols="12" md="4">
              <span>Radio/CD Player</span>
          <v-checkbox
              v-model="vehicleData.Radio"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Radio"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Wipers: </span>
          <v-checkbox
              v-model="vehicleData.Wipers"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Wipers"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Front Seats: </span>
          <v-checkbox
              v-model="vehicleData.FrontSeats"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.FrontSeats"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Row 1 Seats: </span>
          <v-checkbox
              v-model="vehicleData.FrontRow"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.FrontRow"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Row 2 Seats: </span>
          <v-checkbox
              v-model="vehicleData.BackRow"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.BackRow"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          

          <v-col cols="12" md="4">
              <span>Carpet/Floors: </span>
          <v-checkbox
              v-model="vehicleData.Carpet"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Carpet"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12" md="4">
              <span>Headliner/Ceiling: </span>
          <v-checkbox
              v-model="vehicleData.Ceiling"
              label="Yes"
              value="Yes"
              dense
          ></v-checkbox>
          <v-checkbox
              v-model="vehicleData.Ceiling"
              label="No"
              value="No"
              dense
          ></v-checkbox>
          </v-col>

          <v-col cols="12">
              <h2>EMERGENCY</h2>
          </v-col> -->


          

          

          <v-col cols="12">
              <v-textarea
                  label="Description of Activity"
                  outlined
                  v-model="vehicleData.Description"
              ></v-textarea>
          </v-col>

          <v-col cols="12" sm="6">
          <form enctype="multipart/form-data">
              <v-file-input   
              v-model="imageNames"
              class="pa-2"
              label="Upload Front, Left, Right, and Rear Images"
              filled
              multiple
              prepend-icon="mdi-camera"
              accept="image/*"
              @change="imgSelected"
              show-size
              >
              <template #selection="{ text, index }">
                  <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
              </template>
              </v-file-input>
          
          </form>
          </v-col>
          <v-carousel v-if="documents.length > 0">
          <template v-for="(image, index) in documents">
              <v-carousel-item 
              :key="index"
              > 
              <v-row class="flex-nowrap" style="height:80%"> 
                  <v-img :src="image.AWSLink">
                  <v-row class="fill-height"
                          align="center"
                          justify="center"
                  >
                      <div style="color: #000;padding-top: 30%;">{{ image.Name }}</div>
                  </v-row>

                  </v-img>
                  
              </v-row> 
              </v-carousel-item> 
          </template>
          </v-carousel>
          <v-col class="d-flex" cols="12" sm="12">
          <template >
              <v-img
              :src="newImageLink"
              height="200px;"
              ></v-img>
          </template>
          </v-col>

          <v-col cols="12">
              <v-checkbox
                  label="Staff Check In Signature"
                  v-model="vehicleData.CheckInSignature"
                  @click="signCheckIn"
              ></v-checkbox>
              <v-text-field
                  v-if="vehicleData.CheckInSignature"
                  label="Staff Check In Signature"
                  v-model="vehicleData.CheckIn"
                  readonly
              ></v-text-field>
          </v-col>

          <v-col cols="12">
              <v-checkbox
                  label="Staff Check Out Signature"
                  v-model="vehicleData.CheckOutSignature"
                  @click="signCheckOut"
              ></v-checkbox>
              <v-text-field
                  v-if="vehicleData.CheckOutSignature
                  "
                  label="Staff Check Out Signature"
                  v-model="vehicleData.CheckOut"
                  readonly
              ></v-text-field>
          </v-col>

          <v-col cols="12">
              <v-textarea
                  label="Notes or Repair From Trip"
                  outlined
                  v-model="vehicleData.Notes"
              ></v-textarea>
          </v-col>
          
      </v-row>
      </v-container>
  </v-card-text>

  <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="#259647" class="white--text" @click="addInspection()" v-if="newInspection">Save</v-btn>
      <v-btn 
        fab 
        small
        @click="printItem()"
        class="mr-8 mb-2 white--text"
        color="#2b6993"
        elevation="4"
        v-if="editInspection"
        >
        <v-icon>print</v-icon>
    </v-btn>
      <v-btn color="#259647"  class="white--text" @click="updateVehicleInspection()" v-if="editInspection">Update

      </v-btn>
      <v-btn color="blue darken-1" text @click="cancel()" >Cancel</v-btn>
  </v-card-actions>
  </v-card>
</template>

<script>
import axios from 'axios';
const url = require("@/client_config/config").url;

export default {
    props: {
        vehicleData: Object,
        documents: {
            type:Array,
            required:false,
            default(){return []}
        },
        mode: {
            type: String,
            required: true,
            default(){
                return 'add'
            }
        },
        VehicleType: {
            type: String,
            required: false
        }
    },

    data: () => ({
        vehicles: [],
        menu: false,
        menu2: false,
        uploadImg: "",
        newImageLink: "",
        checkInSignature: false,
        checkOutSignature: false,
        newNotes: "",
        removedDocuments:[],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        requiredField: [
            v => !!v || 'This is required',
        ],
        state: localStorage.getItem('userState'),
    }),
    methods: {
        imgSelected(e) {
            this.uploadImg=e;
        },

        signCheckIn() {
            this.vehicleData.CheckIn = localStorage.getItem('Name') + " - " + new Date()
        },

        signCheckOut() {
            this.vehicleData.CheckOut = localStorage.getItem('Name') + " - " + new Date()
        },

        updateVehicleInspection(){
            this.vehicleData.VehicleType = this.VehicleType;

            axios.put(`${url}/inspections/${this.vehicleData._id}`, this.vehicleData).then((response) => {
                let message = 'Updated vehicle inspection.';
                if (response.status == 400) {
                    message = 'Failed to update vehicle inspection.';
                    this.closeComponent({
                        '_id': this.vehicleData._id,
                        'message': message
                    });
                }

                this.saveImg();
                if (this.removedDocuments.length > 0) {
                    this.deleteImages();
                }                
                
                this.closeComponent({
                    '_id': this.vehicleData._id,
                    'message': message
                });
            });
        },

        addInspection(){
            this.vehicleData.VehicleType = this.VehicleType;
            axios.post(`${url}/inspections`, this.vehicleData ).then(res => {
                let message = "The new inspection has been added successfully.";
                if (res.status == 400) {
                    message = 'Failed to add vehicle inspection. '

                    this.closeComponent({
                        '_id': this.vehicleData._id,
                        'message': message
                    });
                }
                this.msg=true;
                this.text="The new inspection has been added successfully.";
                this.inspectionID = res.data._id;
                this.saveImg();

                this.closeComponent({
                    '_id': this.vehicleData._id,
                    'message': message
                });
            });
        },

        saveImg(){
            for (let i = 0; i < this.uploadImg.length; i++) {
                this.uploadFiles(this.uploadImg[i]);
            }
        },

        uploadFiles(file) {
            const formData = new FormData();
            formData.append('vehicle-inspection-img', file);
            var ct = { headers:{"content-type" : "multipart/form-data"}};
            axios.post(`${url}/inspections/imguploader/${this.inspectionID}`,formData, ct)
            .then(res => {
                console.log(res);
                //this.documents.push(res);
            })
            .catch(err => {
                this.closeComponent({
                    '_id': this.inspectionID,
                    'message': err.message
                });
            });
        },

        cancel(){
            this.closeComponent({
                '_id': null,
                'message': ""
            });
        },

        closeComponent(data){
            this.$emit('closeVehicleInspectionForm', data);
        },

        deleteChip(index) {
            this.removedDocuments.push(this.documents[index]);
            this.documents.splice(index, 1);
        },

        deleteImages() {
            this.removedDocuments.forEach(document => {
                axios.delete(`${url}/documents/${document._id}`)
                .then(res => {
                    if (res.status === 204)  {
                        console.log(document._id + ' has been deleted.');
                    }
                    const documentIndex = this.returnVehicleDocuments.findIndex(returnDocument => returnDocument._id === document._id);
                    this.returnVehicleDocuments.splice(documentIndex, 1);
                })
                .catch(err => {
                    console.log(err);
                }); 
            });
        },
        getVehicles() {
            axios.get(`${url}/vehicles/active/${this.state}`)
            .then(res => {
                this.vehicles = res.data.vehicles.map(vehicle => `${vehicle.Year + ' ' + vehicle.Make + ' ' + vehicle.Model}` )
                    .sort();
            })
        },
  
        printItem() {
            this.$emit('print-vehicle-item');
        },
    },
    computed: {
        showOtherOption(){
            if (this.VehicleType === 'Other') return true;
            return false;
        }, 
        titleForm(){
            if (this.mode === 'edit') {
                return 'Viewing Inspection';
            }

            return 'New Inspection';
        },
        editInspection(){
            if (this.mode === 'edit') {
                return true;
            }
            return false;
        },
        newInspection(){
            if (this.mode === 'edit') {
                return false;
            }
            return true;
        },
        inspectionID(){
            if (this.vehicleData._id) return this.vehicleData._id;
            return null;
        }, 
        
        imageNames(){
            return this.documents.map((image) => {
                return {'name': image.Name}
            });
        }
    },
    created() {
        this.getVehicles();
    }
}

</script>
